<template>
	<div class="swiper_view" :style="{ 'height': height ,'width': width}" >
	  <van-swipe class="my-swipe" autoplay= '3000' indicator-color="white" :show-indicators="showindicators" :style="{ 'height': height, 'border-radius': bRadius }" >
      <van-swipe-item v-for="(item, index) in swipeList" :key="index" @click="jump(item)">
        <img v-if="item.advertising_image" :src="item.advertising_image" alt=""  class="swiper_img"/>
        <img v-else :src="item" alt=""  class="swiper_img"/>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
	export default {
		props: {
			swipeList: {//轮播图数据
				type: Array,
				default: []
			},
      height: {//轮播图高度
        type: String,
        default: ''
      },
      width: {//轮播图宽度
        type: String,
        default: '100%'
      },
      showindicators: {//是否展示轮播图指示白点
        type: Boolean,
				default: true
      },
      bRadius: {//轮播图圆角
        type: String,
        default: '6px'
      },
		},
		data() {
			return {
       
			}
		},

		mounted() {
      console.log(this.bRadius)
    },
		methods: {
      jump(data){
        if(data.advertising_link){
          window.location.href = data.advertising_link
        }
      }
		}
	}
</script>
<style lang="less" scoped>
.swiper_view{
  margin:0 auto;
  box-sizing: border-box;
  .my-swipe{
    border-radius:6px;

    .swiper_img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
